import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

export interface ICashHubCard {
  rate: string;
  notice: number;
  term: number;
  productType: string;
  easyAccessLabel: string;
  fixedRateBondLabel: string;
  noticeAccountLabel: string;
}

const CashHubCard: FunctionComponent<ICashHubCard> = ({
  rate,
  notice,
  term,
  productType,
  easyAccessLabel,
  noticeAccountLabel,
  fixedRateBondLabel,
}) => {
  const getDescription = () => {
    if (productType == "INSTANT") {
      return easyAccessLabel;
    }
    if (productType == "NOTICE") {
      return `${noticeAccountLabel} - ${notice} days`;
    }
    if (productType == "TERM") {
      return `${fixedRateBondLabel}- Over ${term} months`;
    }
  };

  return (
    <div className="promo-card cashhub-block visible cashhub-block__card">
      <div className="promo-card__inner container">
        <div className="container__inner">
          <div className="promo-card__card skin--backgrounded promo-card__card--backgrounded backgrounded">
            <i className="promo-card__decorative-quirk decorative-quirk js-visible"></i>
            <h2 className="promo-card__title cashhub-block__card--title">{rate}% AER</h2>
            <div className="promo-card__content richtext-content cashhub-block__card--description">
              <p>{getDescription()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashHubCard;
